<template>
  <div>
    <v-card>
      <v-card-title>更新预订Header参数</v-card-title>
      <v-form ref='formPlaceUsing'>
        cookie:<br />
        示例：<br />
        <span style='white-space: pre-line;opacity: 0.6'>
          {{ placeholder }}
        </span>
        <v-textarea
          outlined
          class='required mx-4'
          label='cookie'
          v-model='placeUsingCookie'
          clearable
          no-resize
          :rules='[v => !!v]'
        ></v-textarea>
        token:
        <v-textarea
          outlined
          label='token'
          class='required mx-4'
          v-model='placeUsingToken'
          clearable
          no-resize
          :rules='[v => !!v]'
          rows='1'
        ></v-textarea>
        <v-alert v-if='placeUsingMessage'
                 :type='placeUsingType'
        >{{ placeUsingMessage }}
        </v-alert>

        <v-btn class='primary' @click='updatePlaceUsingHeader' style='font-size: 1rem'
               :loading='placeUsingHeaderBtnLoading'>
          修改预订Header参数
        </v-btn>
      </v-form>
    </v-card>

    <v-card style='margin-top: 50px;margin-bottom: 50px'>
      <v-card-title>更新房间改变Header参数</v-card-title>
      <v-form ref='formRoomChange'>
        cookie:<br />
        示例：<br />
        <span style='white-space: pre-line;opacity: 0.6'>
          {{ placeholder }}
        </span>
        <v-textarea
          outlined
          class='required mx-4'
          label='cookie'
          v-model='roomChangeCookie'
          clearable
          no-resize
          :rules='[v => !!v]'
        ></v-textarea>
        token:
        <v-textarea
          outlined
          label='token'
          class='required mx-4'
          v-model='roomChangeToken'
          clearable
          no-resize
          :rules='[v => !!v]'
          rows='1'
        ></v-textarea>
        <v-alert v-if='roomChangeMessage'
                 :type='roomChangeType'
        >{{ roomChangeMessage }}
        </v-alert>

        <v-btn class='primary' @click='updateRoomChangeHeader' style='font-size: 1rem'
               :loading='roomChangeHeaderBtnLoading'>
          修改房间改变Header参数
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>


import { updatePlaceUsingHeader, updateRoomChangeHeader } from '@/modules/management/api'
import { getLookUpByClassifyCodeV2 } from '@/modules/chat/api/index'

export default {
  name: 'updateApiHeader',
  data() {
    return {
      placeUsingToken: '',
      placeUsingCookie: '',
      placeUsingMessage: '',
      placeUsingType: '',
      placeUsingHeaderBtnLoading: false,
      roomChangeToken: '',
      roomChangeCookie: '',
      roomChangeMessage: '',
      roomChangeType: '',
      roomChangeHeaderBtnLoading: false,
      placeholder: 'glide_sso_id=453cddad8356a1105a877d55eeaad3b1;\n' +
        'BIGipServerpool_accentureinternalworkplace=c85e41d8ba88bab896da1d7342f60a1d;\n' +
        'glide_user_route=glide.cac5c9f6d787b58f59929a1699a4ca91;\n' +
        'glide_node_id_for_js=57aa94777af1c539c2cae0adbabaeef3a1c18f35886a9580718bb5c8ede2ce8f;\n' +
        'JSESSIONID=EB4E55C1EB895A9058A043324816D4E8;\n' +
        'glide_user_activity=U0N2M18xOldWOGc0SUR5MmYvOElPT1VIbGx0dVUwRE5GRERHd3N5N2VyWDlDYlZ3S2M9Om9kbllDRVhYbkxRejFILzJBNlY5TTFOMWIyUzE1bk1SNFJ3OHdXZXRKalE9;\n' +
        'glide_session_store=25A15999838A2E105DABBCA6FEAAD38F',
    }
  },
  methods: {
    async updatePlaceUsingHeader() {
      this.placeUsingHeaderBtnLoading = true
      this.placeUsingMessage = null
      if (this.$refs.formPlaceUsing.validate()) {
        const param = {
          cookie: this.setCookie(this.placeUsingCookie),
          token: this.placeUsingToken,
        }
        const { data: { data, code, msg } } = await updatePlaceUsingHeader(param)
        if (code === 200) {
          this.placeUsingMessage = msg
          this.placeUsingType = 'success'
        } else {
          this.placeUsingMessage = '修改失败!' + msg
          this.placeUsingType = 'error'
        }
      }
      await this.getApiHeader()
      this.placeUsingHeaderBtnLoading = false
    },
    // 正确设置Cookie的示例
    setCookie(cookie) {
      let cleanedString = cookie.replace(/[\n\r\s]/g, '')
      if (!cleanedString.endsWith(';')) {
        cleanedString = cleanedString + ';'
      }
      return cleanedString
    },
    async getApiHeader() {
      const {
        data: {
          code,
          data,
        },
      } = await getLookUpByClassifyCodeV2({ classifyCode: 'PLACE_USING_HEADER' })
      if (code === 200) {
        data.forEach(item => {
          if (item.code === 'token') {
            this.placeUsingToken = item.value
          }
          if (item.code === 'cookie') {
            this.placeUsingCookie = item.value
          }
        })
      }
    },
    async updateRoomChangeHeader() {
      this.roomChangeHeaderBtnLoading = true
      this.roomChangeMessage = null
      if (this.$refs.formRoomChange.validate()) {
        const param = {
          cookie: this.setCookie(this.roomChangeCookie),
          token: this.roomChangeToken,
        }
        const { data: { data, code, msg } } = await updateRoomChangeHeader(param)
        if (code === 200) {
          this.roomChangeMessage = msg
          this.roomChangeType = 'success'
        } else {
          this.roomChangeMessage = '修改失败!' + msg
          this.roomChangeType = 'error'
        }
      }
      await this.getRoomChangeApiHeader()
      this.roomChangeHeaderBtnLoading = false
    },
    async getRoomChangeApiHeader() {
      const {
        data: {
          code,
          data,
        },
      } = await getLookUpByClassifyCodeV2({ classifyCode: 'ROOM_CHANGE_HEADER' })
      if (code === 200) {
        data.forEach(item => {
          if (item.code === 'token') {
            this.roomChangeToken = item.value
          }
          if (item.code === 'cookie') {
            this.roomChangeCookie = item.value
          }
        })
      }
    },
  },
  async created() {
    await this.getApiHeader()
    await this.getRoomChangeApiHeader()
  },
}
</script>

<style scoped>

</style>
